import { Filter } from '@vindr/ui';
import { ASSIGNED_STATUS } from '@vindr/services/constants/assigned.constant';
import { filterBothValueAndKey } from '@vindr/utils/helpers/common.helper';
import { CaretDownOutlined } from '@vindr/icons';
import { DateRangePicker } from '@vindr/ui';
import { extendDateOptions } from '@vindr/ui/src/components/ui/DateRangePicker';
import { Input, Select } from 'antd';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FILTER_TYPE } from './constants';

const { Option } = Select;

const useSearchOptions = (params, handleOnChangeFilter) => {
  const { t } = useTranslation('Vindoc');

  const InputItem = (params, key, placeholder = t('Keyword')) => {
    return (
      <Input
        size="small"
        className="w-[200px]"
        value={params[key]}
        placeholder={placeholder}
        onChange={(event) => handleOnChangeFilter(params, key, event?.target?.value)}
        onPressEnter={(event) => handleOnChangeFilter(params, key, event?.target?.value, true)}
      />
    );
  };

  return useMemo(
    () => [
      {
        text: t('Institution'),
        key: FILTER_TYPE.INSTITUTION,
        component: (
          <Filter.Institution
            size="small"
            multiple
            className="select-dropdown-light w-[200px]"
            popupClassName="dropdown-options-dark"
            onChange={(value) => {
              handleOnChangeFilter(params, FILTER_TYPE.INSTITUTION, value, true);
            }}
            value={params[FILTER_TYPE.INSTITUTION] || []}
            filterOption={filterBothValueAndKey}
            title={false}
          />
        ),
      },
      {
        text: t('Assigned At'),
        key: FILTER_TYPE.ASSIGNED_AT,
        component: (
          <DateRangePicker
            size="small"
            // allowClear={false}
            value={[
              params.assigned_at_from
                ? dayjs(params.assigned_at_from)
                : extendDateOptions['This Month'][0],
              params.assigned_at_to
                ? dayjs(params.assigned_at_to)
                : extendDateOptions['This Month'][1],
            ]}
            // style={{ width: '100%' }}
            // formatDate={formatDate}
            // popupClassName="date-picker-light"
            onChange={(values) => {
              handleOnChangeFilter(
                params,
                FILTER_TYPE.ASSIGNED_AT,
                [values[0].startOf('days'), values[1].endOf('days')],
                true
              );
            }}
            disabledDate={() => false}
          />
        ),
      },
      {
        text: t('Visit ID'),
        key: FILTER_TYPE.VISIT_ID,
        component: InputItem(params, FILTER_TYPE.VISIT_ID, t('Enter Visit ID')),
      },
      {
        text: t('Patient Name'),
        key: FILTER_TYPE.PATIENT_NAME,
        component: InputItem(params, FILTER_TYPE.PATIENT_NAME, t('Enter Patient Name')),
      },
      {
        text: t('Order Group'),
        key: FILTER_TYPE.ORDER_GROUP,
        component: InputItem(params, FILTER_TYPE.ORDER_GROUP, t('Enter Order Group')),
      },
      {
        text: t('Status'),
        key: FILTER_TYPE.STATUS,
        component: (
          <Select
            size="small"
            // allowClear
            // maxTagCount="responsive"
            suffixIcon={<CaretDownOutlined />}
            placeholder={t('Select Status')}
            className="select-dropdown-light w-[200px]"
            popupClassName="dropdown-options-dark"
            onChange={(value) => {
              handleOnChangeFilter(params, FILTER_TYPE.STATUS, value, true);
            }}
            value={params[FILTER_TYPE.STATUS]}
          >
            <Option value={ASSIGNED_STATUS.NEW}>{t('NEW')}</Option>
            <Option value={ASSIGNED_STATUS.READING}>{t('READING')}</Option>
            <Option value={ASSIGNED_STATUS.COMPLETED}>{t('COMPLETED')}</Option>
          </Select>
        ),
      },
      {
        text: t('Patient ID'),
        key: FILTER_TYPE.PATIENT_ID,
        component: InputItem(params, FILTER_TYPE.PATIENT_ID, t('Enter Patient ID')),
      },
      {
        text: t('Study Description'),
        key: FILTER_TYPE.STUDY_DESC,
        component: InputItem(params, FILTER_TYPE.STUDY_DESC, t('Enter Study Description')),
      },
    ],
    [t, params, handleOnChangeFilter]
  );
};

export default useSearchOptions;
